<template>
  <SelectSearch
    instant
    v-model="localValue"
    @search="search"
    :options="options"
    placeholderKey="name"
    :placeholder="props.placeholder"
    :allowEmptyValue="props.allowNew"
    v-slot="{ option, selected }"
  >
    <SelectListItemWithSecondaryText
      :option="decorate(option)"
      :selected="selected"
      primaryKey="name"
      secondaryKey="email"
    />
  </SelectSearch>
</template>

<script setup>
import SelectSearch from '@/Common/Forms/SelectMenus/SelectSearch.vue'
import SelectListItemWithSecondaryText from '@/Common/Forms/SelectMenus/SelectListItemWithSecondaryText.vue'
import { computed, ref } from 'vue'
import { Inertia } from '@inertiajs/inertia'

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
  modelValue: {
    required: true,
  },
  placeholder: {
    type: String,
    default: 'Type a name or email...',
  },
  // Let the admin type a name that doesn't match anyone to create a new person
  allowNew: Boolean,
  except: {
    type: Array,
    default: () => [],
  },
})

const localValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  },
})

// The "new person" option SelectSearch synthesizes has no id
function decorate(option) {
  if (option.id === null) return { ...option, email: 'New person' }
  return option
}

const options = ref([])

let search = _.debounce(function (query) {
  axios
    .get(route('users.search'), {
      params: { query: query, except: props.except },
    })
    .then((response) => {
      options.value = response.data
    })
    .catch(() => Inertia.reload())
}, 350)
</script>
